import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Pm10010View from "../../Views/Purchase/PM10010";
import Snackbar from "../../Components/Snackbar";

function PM10010(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [checkInputs, setCheckInputs] = React.useState({
    value1: new Date(),
    value2: "",
    value3: "",
    itemType: "",
  });
  //재고체크 안 품목코드 설정
  const [checkInputs1, setCheckInputs1] = React.useState({
    value1: "",
    value2: "",
    value3: "",
    itemType: "",
    comboList: [],
  });
  const [inputs, setInputs] = React.useState({
    comboInwh: [], //창고
    comboPoType: [], //거래유형
    comboList: [],
    comboUnit: [],
    comboCurrencyCd: [],
    poCreateDt: new Date(), //일자
    plantCd: "",
    custCd: "", //거래처
    poNo: "", //발주번호
    createId: "", //담당자
    inWh: "WH_IN", //입고창고
    delivDt: new Date(), //납기일자
    poType: "PO_TYPE", //거래유형
    currencyCd: "CU_01", //통화
    arrivCustCd: "", //납품장소코드
    arrivCustNm: "", //납품장소
    reference: "", //참조
    filePath: "", //첨부
    poDelivReqDt: new Date(), //납품요청일
    poForeignAmt: "",
    poWonAmt: "",
  });
  const [totalInputs, setTotalInputs] = React.useState({
    totalAmt: 1,
    currencyAmt: 1,
    currencyNm: "",
    kTotalAmt: 0,
  });
  const [addEventController, setAddEventController] = React.useState("0");
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [saveYn, setSaveYn] = React.useState(true);
  const [authGroupGridRowData, setAuthGroupGridRowData] = React.useState([]);
  const [authGroupGridRowData1, setAuthGroupGridRowData1] = React.useState([]);
  const [authGroupGridRowData2, setAuthGroupGridRowData2] = React.useState([]);
  const [authGroupGridRowData3, setAuthGroupGridRowData3] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [reportInputs, setReportInputs] = React.useState({
    tapValue: "tap1",
    deptCdList: [], //CoCd list
    deptList: [], //Dept list
    tablevendor: [], //report vendor data
    tablestore: [], //report store data
    tablegoods: [], //report goods data
  });

  const [ponoSave, setPoNoSave] = React.useState("");
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  let selectedPoNo = "";
  const [endDate, setEndDate] = React.useState(new Date());

  React.useEffect(() => {
    if (addEventController === "1") {
      setSnackbars({
        toggle: true,
        type: "error",
        message: "수량을 입력해주세요",
      });
      setAddEventController("0");
    }
  }, [addEventController]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    let getComboData1 = [];
    let getCurrencyData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      //창고콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh,
        {
          whCd: "string",
        }
      ).then((result) => {
        let data = result.data;

        for (let i = 0; i < data.length; i++) {
          getComboData1.push({
            value: data[i].value,
            name: data[i].name,
          });
        }

        inputs.comboInwh = getComboData1.filter(
          (e) => e.value.substring(0, 5) === "WH_IN"
        );
      });
      //콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            groupCd: data[i].GroupCd,
            value: data[i].Code,
            name: data[i].Name,
          });
        }
        inputs.comboList = getComboData.filter((e) => e.groupCd == "ITEM_TYPE");
        // inputs.comboInwh = getComboData.filter(
        //   (e) => e.groupCd == "WH_CD" && e.value.substring(0, 5) === "WH_IN"
        // );
        inputs.comboPoType = getComboData.filter(
          (e) => e.groupCd == "CD_GUBUN"
        );
        inputs.comboCurrencyCd = getComboData.filter(
          (e) => e.groupCd == "CURRENCY_CD" && e.value != "CURRENCY_CD"
        );
        checkInputs1.comboList = getComboData.filter(
          (e) => e.groupCd == "ITEM_TYPE" && e.value == "ITEM_TYPE_01"
        );
        inputs.comboUnit = getComboData.filter((e) => e.groupCd == "ITEM_UNIT");
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.GetPurchaseOrder,
        {
          StartDate: new Date(startDate),
          EndDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              poCreateDt: data[i].poCreateDt
                ? Commons.DateFormating(data[i].poCreateDt.toString(), 2)
                : "",
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              poNo: data[i].poNo,
              createId: data[i].createId,
              inWh: data[i].inWh,
              delivDt: data[i].delivDt
                ? Commons.DateFormating(data[i].delivDt.toString(), 2)
                : "",
              poType: data[i].poType,
              poStusCd: data[i].poStusCd,
              poStusNm: data[i].poStusNm,
              currencyCd: data[i].currencyCd,
              currencyNm: data[i].currencyNm,
              arrivCustNm: data[i].arrivCustNm,
              reference: data[i].reference,
              filePath: data[i].filePath,
              poDelivReqDt: data[i].poDelivReqDt
                ? Commons.DateFormating(data[i].poDelivReqDt.toString(), 2)
                : "",
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetPurchaseOrderDtl = async (_pono) => {
    Dialog.ProgressBar(true);
    let getRowData = [];
    setPoNoSave(_pono);
    selectedPoNo = _pono;
    let totalAmt1 = 0;
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.GetPurchaseOrderDtl,
        { poNo: _pono }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setTotalInputs({
            ...totalInputs,
            totalAmt: 1,
            currencyAmt: 1,
          });
          setRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              poAddItemQty: data[i].poAddItemQty,
              poItemQty: data[i].poItemQty,
              itemUnitNm: data[i].itemUnit,
              itemStdAmt: data[i].itemStdAmt,
              whCd: data[i].whCd,
              whNm: data[i].whNm,
              poForeignAmt: data[i].poForeignAmt,
              poWonAmt: data[i].poWonAmt,
              poItemVat: data[i].itemVatYn === "Y" ? data[i].poItemVat : 0,
              poRemarkDtl: data[i].poRemarkDtl,
              poItemCost: data[i].poItemCost,
              itemVatYn: data[i].itemVatYn,
              itemFormula: data[i].itemFormula,
              remark: data[i].remark,
            });
            totalAmt1 += data[i].itemStdAmt * data[i].poItemQty;
            setTotalInputs({
              ...totalInputs,
              totalAmt: totalAmt1,
            });
            setRowData1(Commons.InsertNumber(getRowData));
          }
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const Print = async () => {
    let headerData = [];
    let tableData = [];
    let address;
    let purchaseDtlData = [];
    //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);

    //address = "http://114.206.84.134:5540/PurchaseOrder/PurchaseOrder"; //http://localhost:65061/ 114.206.84.134:5540
    address =
      "https://dongsungprintingmes.com:8082/PurchaseOrder/PurchaseOrder"; //http://localhost:65061/ https://dongsungprintingmes.com:8082/PurchaseOrder/PurchaseOrder

    if (
      selectedRowData.length === 0 ||
      selectedRowData[0].woNo === "" ||
      selectedRowData[0].woNo === null
    ) {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) => f.lanId === "Snack_SelectTask" && f.lanType === "SNACK"
        )[0].lanName,
      });
    } else {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.GetPrintData,
        {
          poNo: selectedRowData[0].poNo,
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          tableData.push({
            ItemCd: data[i].itemCd,
            ItemNm: data[i].itemNm,
            PoAddItemQty:
              data[i].poAddItemQty == null
                ? 0
                : data[i].poAddItemQty.toString(),
            PoRemarkDtl: data[i].poRemarkDtl ? data[i].poRemarkDtl : "",
          });
        }
        headerData.push({
          ReportTitle: "발주서",
          poCreateDt: data[0].poCreateDt.slice(0, 10),
          DelivDt: data[0].delivDt.slice(0, 10),
          SerialNm: data[0].delivDt, //일련번호 날짜+순서
          CustNm: data[0].custNm, //거래처
          Reference: data[0].reference, //참조
          CustTel: data[0].custTel, //거래처번호
          FaxNo: data[0].faxNo, //팩스
          BusinessLineNo: data[0].businessLineNo, //사업자등록번호
          ArrivCustNm: data[0].arrivCustNm, //회사명
          ArrivCeo: data[0].arrivCeoNm ? data[0].arrivCeoNm : "", //대표
          ArrivAdress1: data[0].arrivAdress1, //주소
          ArrivPersonCharg: data[0].arrivPersonCharg, //담당
          ArrivCustTel: data[0].arrivCustTel ? data[0].arrivCustTel : "", //연락처
          // PurchaseDtlData: purchaseDtlData,
          //품목코드
          //품목명
          //추가수량
          //적요
        });

        var f = document.createElement("form");
        f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
        f.method = "POST";
        f.target = "_blank";

        var k = document.createElement("input");
        k.type = "hidden";
        k.name = "headerData";
        k.value = JSON.stringify(headerData);
        f.append(k);
        var l = document.createElement("input");
        l.type = "hidden";
        l.name = "tableData";
        l.value = JSON.stringify(tableData);
        f.append(l);
        document.body.appendChild(f);

        f.submit();
      });
    }
  };
  const SaveConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        if (_type === "save") {
          SaveLogic();
        } else {
          SaveItmLogic();
        }
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);

    let salesOrders = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (inputs.custCd === "") {
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.CreatePurchaseOrders,

        {
          plantCd: inputs.plantCd,
          poNo: inputs.poNo,
          poCreateDt: inputs.poCreateDt,
          custCd: inputs.custCd,
          inWh: inputs.inWh,
          delivDt: Commons.DateStrChange(inputs.delivDt),
          poType: inputs.poType,
          currencyCd: inputs.currencyCd,
          arrivCustCd: inputs.arrivCustCd,
          reference: inputs.reference,
          filePath: inputs.filePath,
          poDelivReqDt: Commons.DateStrChange(inputs.poDelivReqDt),
          poStusCd: inputs.poStusCd,
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        }
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
          SearchLogic();
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveItmLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication1(changedRowData1);
    let getData = [];
    let salesOrders = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < rowData1.length; i++) {
        if (rowData1[i].whNm == null) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_CheckInWh" && f.lanType === "SNACK"
            )[0].lanName,
          });
          return false;
        } else if (
          rowData1[i].poItemQty === undefined ||
          rowData1[i].poAddItemQty === NaN
        ) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_CheckQty" && f.lanType === "SNACK"
            )[0].lanName,
          });
          return false;
        }
        getData.push({
          plantCd: inputs.plantCd,
          poNo: ponoSave,
          itemCd: rowData1[i].itemCd,
          poItemQty: rowData1[i].poItemQty,
          poAddItemQty: rowData1[i].poAddItemQty,
          poItemCost: rowData1[i].poItemCost,
          poForeignAmt: rowData1[i].poForeignAmt,
          poWonAmt: rowData1[i].poWonAmt,
          poItemVat: rowData1[i].poItemVat,
          currencyCd: inputs.currencyCd,
          poRemarkDtl: rowData1[i].poRemarkDtl,
          whCd:
            !rowData1[i].whNm || rowData1[i].whNm.value == undefined
              ? rowData1[i].whCd
              : rowData1[i].whNm.value,
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        });
      }

      await Commons.Axios(
        "post1",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.CreatePurchaseOrderDtls,
        getData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
          setChangedRowData1([]);
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setChangedRowData1([]);

          GetPurchaseOrderDtl(ponoSave);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        if (_type == "G02") {
          DeleteDetailLogic();
        } else {
          DeleteLogic();
        }
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    if (selectedRowData[0].poStusNm === "입고완료") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) =>
            f.lanId === "Dia_Message_ReceivedData" && f.lanType === "DIALOG"
        )[0].lanName,
      });
      Dialog.ProgressBar(false);
      return false;
    }
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData.length; i++) {
        deleteData.push({
          plantCd: selectedRowData[i].plantCd,
          poNo: selectedRowData[i].poNo,
          itemCd: selectedRowData[i].itemCd,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.DeletePurchaseOrder,
        deleteData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
          setChangedRowData1([]);
        } else {
          SearchLogic();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setChangedRowData1([]);

          GetPurchaseOrderDtl(ponoSave);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const DeleteDetailLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    if (selectedRowData[0].poStusNm === "입고완료") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) =>
            f.lanId === "Dia_Message_ReceivedData" && f.lanType === "DIALOG"
        )[0].lanName,
      });
      Dialog.ProgressBar(false);
      return false;
    }
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData1.length; i++) {
        deleteData.push({
          plantCd: selectedRowData1[i].plantCd,
          poNo: ponoSave,
          itemCd: selectedRowData1[i].itemCd,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.DeletePurchaseOrderDtls,
        deleteData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
          setChangedRowData1([]);
        } else {
          SearchLogic();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setChangedRowData1([]);

          GetPurchaseOrderDtl(ponoSave);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //재고체크버튼
  const CheckStockLogic = async (_itemCd, _workQty) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let lossQty = null;
    try {
      if (!_itemCd) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_SelectData" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      } else if (_workQty === "" || _workQty === null) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_CheckWorkQty" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      }
      // else if (!selectedRowData[0].soNo) {
      //   throw new Error("주문번호를 설정해주세요");
      // }
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10010.GetStockChk,
        {
          itemCd: _itemCd,
          workQty: _workQty,
          // workDt: formattedDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setAuthGroupGridRowData2([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setAuthGroupGridRowData2([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              stockDt: data[i].stockDt
                ? Commons.DateFormating(data[i].stockDt.toString(), 2)
                : "",
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              stockQty: data[i].stockQty !== 0 ? data[i].stockQty : "0",
              usedQty: data[i].usedQty !== 0 ? data[i].usedQty : "0",
              lossQty:
                data[i].stockQty - data[i].usedQty < 0
                  ? data[i].stockQty - data[i].usedQty
                  : "0",
            });
            if (data[i].stockQty < data[i].usedQty) {
              // setSaveYn(false);
            } else {
              // setSaveYn(true);
            }
          }
          // if (saveYn === false) {
          //   throw new Error("수량이 부족합니다.");
          // }
          setAuthGroupGridRowData2(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const CustNmHelper = async (_custCd, _arrivChk) => {
    Dialog.ProgressBar(true);
    let getRowData = [];
    let getData = [];

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCustList,
        {
          plantCd: "string",
          value: _custCd === "" ? "string" : _custCd,
        }
      ).then((result) => {
        let data = result.data;

        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          if (_arrivChk === "Y") {
            data = data.filter((x) => x.custType === "CT_06");
          }
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              custNm: data[i].custNm,
              custCd: data[i].custCd,
              personCharg: data[i].personCharg,
              arrivCustCd: data[i].custNm,
            });
          }
          setAuthGroupGridRowData(getData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetCommonItemList = async (_value, _chk) => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList4,
        {
          custCd: _chk == "1" ? "string" : inputs.custCd,
          plantCd: _chk == "1" ? "string" : inputs.plantCd,
          itemType:
            _chk == "1"
              ? checkInputs1.itemType === ""
                ? "string"
                : checkInputs1.itemType
              : checkInputs.itemType === ""
              ? "string"
              : checkInputs.itemType,
          value: _value === "" ? "string" : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          if (_chk === "1") {
            setAuthGroupGridRowData3([]);
          } else {
            setAuthGroupGridRowData1([]);
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              itemUnit: data[i].itemUnit,
              itemUnitNm: data[i].itemUnitNm,
              itemStdAmt: data[i].itemStdAmt,
              poItemCost: data[i].poItemCost,
              itemVatYn: data[i].itemVatYn,
              itemFormula: data[i].itemFormula,
              stockQty: data[i].stockQty,
              whNm: data[i].whCd,
            });
          }

          if (_chk === "1") {
            setAuthGroupGridRowData3(getData);
          } else {
            setAuthGroupGridRowData1(getData);
          }
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const Reset = () => {
    setInputs({
      ...inputs,
      poCreateDt: new Date(),
      custCd: "",
      custNm: "",
      poNo: "",
      createId: "",
      inWh: "",
      delivDt: new Date(),
      poType: "",
      currencyCd: "",
      currencyNm: "",
      arrivCustCd: "",
      reference: "",
      filePath: "",
      arrivCustNm: "",
      poDelivReqDt: new Date(),
    });
  };

  return (
    <>
      <Pm10010View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        setChangedRowData={setChangedRowData}
        setChangedRowData1={setChangedRowData1}
        changedRowData1={changedRowData1}
        selectedRowData={selectedRowData}
        selectedRowData1={selectedRowData1}
        setSelectedRowData={setSelectedRowData}
        CheckStockLogic={CheckStockLogic}
        setSelectedRowData1={setSelectedRowData1}
        GetPurchaseOrderDtl={GetPurchaseOrderDtl}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        inputs={inputs}
        setInputs={setInputs}
        SearchLogic={SearchLogic}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        checkInputs1={checkInputs1}
        setCheckInputs1={setCheckInputs1}
        Reset={Reset}
        Print={Print}
        authGroupGridRowData={authGroupGridRowData}
        setAuthGroupGridRowData={setAuthGroupGridRowData}
        authGroupGridRowData1={authGroupGridRowData1}
        setAuthGroupGridRowData1={setAuthGroupGridRowData1}
        authGroupGridRowData2={authGroupGridRowData2}
        setAuthGroupGridRowData2={setAuthGroupGridRowData2}
        authGroupGridRowData3={authGroupGridRowData3}
        setAuthGroupGridRowData3={setAuthGroupGridRowData3}
        CustNmHelper={CustNmHelper}
        GetCommonItemList={GetCommonItemList}
        setAddEventController={setAddEventController}
        addEventController={addEventController}
        totalInputs={totalInputs}
        setTotalInputs={setTotalInputs}
        setSnackbars={setSnackbars}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default PM10010;
